<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Συμβάσεις</u></h4>
        </div>
      </div>

      <div>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="grid-pad">
      <DxDataGrid
        :data-source="contracts"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        key-expr="Id"
        :show-row-lines="true"
        :row-alternation-enabled="true"
      >
        <DxPaging :page-size="20" />
        <DxEditing
          :allow-updating="false"
          :allow-adding="false"
          mode="row"
          :use-icons="true"
        />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" />

        <DxColumn
          caption="Κατηγορία Σύμβασης"
          data-field="ContractCategoryDescription"
          data-type="string"
          :visible="true"
          alignment="left"
          width="200px"
          :group-index="0"
        >
        </DxColumn>

        <DxColumn
          caption="Κωδικός"
          data-field="Id"
          data-type="integer"
          :visible="false"
        >
        </DxColumn>
        <DxColumn
          caption="Voucher"
          data-field="Voucher"
          data-type="string"
          :visible="true"
          alignment="left"
          width="100px"
        >
        </DxColumn>
        <DxColumn
          caption="Δομή"
          data-field="StructureDescription"
          data-type="string"
          :visible="true"
          alignment="left"
          width="250px"
        >
        </DxColumn>
        <DxColumn
          caption="Ωφελούμενη/ος"
          data-field="KidFullName"
          data-type="string"
          :visible="true"
          alignment="left"
          width="250px"
        >
        </DxColumn>
        <DxColumn
          caption="Νόμιμος Εκπρόσωπος"
          data-field="ParentFullName"
          data-type="string"
          :visible="true"
          alignment="left"
          width="250px"
        >
        </DxColumn>
        <DxColumn
          caption="Τύπος χρηματοδότησης"
          data-field="FundingTypeDescription"
          data-type="string"
          :visible="true"
          alignment="left"
          width="140px"
        >
        </DxColumn>

        <DxColumn type="buttons">
          <DxButton
            hint="Πληροφορίες"
            icon="info"
            :on-click="contractInfoClick"
          />
          <DxButton
            hint="Παρουσίες"
            icon="orderedlist"
            :on-click="kidAttendancesClick"
          />
        </DxColumn>
        <DxSummary>
          <DxTotalItem summary-type="count" column="KidFullName" alignment="center" />
        </DxSummary>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";
import router from "../../router";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxButton,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import BackButton from "../../components/shared/backButton";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxButton,
    BackButton,
    DxLoadIndicator,
    DxSummary,
    DxTotalItem,
  },
  data() {
    return {
      contracts: [],
      loadIndicatorVisible: false,
    };
  },
  created() {},
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
    hasFullAccess() {
      return this.$store.getters.getHasFullAccess;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      if (this.hasFullAccess) {
        this.getContracts();
      } else {
        this.contracts = [];
      }
    },
  },
  methods: {
    contractInfoClick(e) {
      router.replace(`/contract/${e.row.data.Id}`);
    },
    kidAttendancesClick(e) {
      router.replace(`/kidAttendanceRecords/${e.row.data.KidId}`);
    },
    async getContracts() {
      this.loadIndicatorVisible = true;
      const res = await mainService.get(
        `/contracts/GetContractsByUserAndOrganization?organizationId=${this.organizationId}`
      );
      this.contracts = res.data;
      this.loadIndicatorVisible = false;
    },
  },
  async mounted() {
    if (this.hasFullAccess) {
      this.getContracts();
    } else {
      this.contracts = [];
    }
  },
};
</script>
